import styled from '@emotion/styled';
import { BREAKPOINTS, mediaQuery, responsiveFontSize } from '@presentation/styles';
import paws from '../assets/paws.svg';

export const Container = styled.div`
  position: relative;
  background-color: ${(props) => props.theme.color.blue.light};
  color: ${(props) => props.theme.color.blue.default};
  border-radius: 8px;
  margin-top: 120px;
  display: flex;
  align-items: center;
  padding: 28px 64px;
  gap: 40px;

  * {
    z-index: 1;
  }

  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 30%;
    height: 80%;
    z-index: 0;
    background-image: url(${paws});
    background-size: cover;
  }

  ${mediaQuery(BREAKPOINTS.tablet)} {
    flex-direction: column;
  }
`;

export const Title = styled.h2`
  ${responsiveFontSize(42, 2)};
`;

export const Text = styled.p`
  margin-top: 16px;
  margin-bottom: 32px;
`;
